import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ApiPortal from '@/views/ApiPortal';
import { ApiDetail, ArticleView, FeatureDemo } from '@/views';

const AppRouter: React.FC = () => {
  return (
    <Routes>
      <Route path='/' element={<ApiPortal />} />
      <Route path='/api-definitions/:slug' element={<ApiDetail />} />
      <Route path='/api-definitions/:slug/article/:articleSlug' element={<ArticleView />} />
      <Route path='/api-definitions/:slug/feature/:featureSlug' element={<FeatureDemo />} />
    </Routes>
  );
};

export default AppRouter;
